// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".color--primary[data-v-221abca2]{color:#c81919}.subtitle--text[data-v-221abca2]{margin-top:20px}@media only screen and (max-width: 768px){.subtitle--text[data-v-221abca2]{margin-top:60px;text-align:center}}", ""]);
// Exports
module.exports = exports;
